"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadEmptyImage = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const UploadEmptyImage = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  width: "140",
  height: "140",
  viewBox: "0 0 140 140",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M70.0001 120C97.6138 120 120 97.6575 120 70C120 42.3425 97.5151 20 70.0001 20C42.3867 20 20.0002 42.3425 20.0002 70C20.0002 97.6575 42.3867 120 70.0001 120Z",
    fill: "#E6E5EF"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M122.1 41.5999C124.364 41.5999 126.2 39.7642 126.2 37.4999C126.2 35.2355 124.364 33.3999 122.1 33.3999C119.835 33.3999 118 35.2355 118 37.4999C118 39.7642 119.835 41.5999 122.1 41.5999Z",
    fill: "#9F9FBC"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M127.8 25.6C129.346 25.6 130.6 24.3464 130.6 22.8C130.6 21.2536 129.346 20 127.8 20C126.253 20 125 21.2536 125 22.8C125 24.3464 126.253 25.6 127.8 25.6Z",
    fill: "#9F9FBC"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M26.3002 33.6C27.8466 33.6 29.1002 32.3464 29.1002 30.8C29.1002 29.2536 27.8466 28 26.3002 28C24.7538 28 23.5002 29.2536 23.5002 30.8C23.5002 32.3464 24.7538 33.6 26.3002 33.6Z",
    fill: "#9F9FBC"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M104.3 108.853L36.6643 109.338C32.7603 109.355 29.5768 106.208 29.5246 102.33L29.0004 37.6185C28.9786 33.7137 32.1217 30.5333 35.9995 30.4854L103.635 30.0001C107.539 29.9827 110.723 33.1299 110.775 37.0085L111.299 101.719C111.321 105.624 108.178 108.805 104.3 108.853Z",
    fill: "white",
    stroke: "#D3D2E0",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M100.492 99.1909L41.0341 99.6409C39.3523 99.6559 37.9986 98.3279 37.9817 96.6459L37.5307 43.1654C37.5138 41.4832 38.8397 40.1307 40.5216 40.1158L99.979 39.6658C101.661 39.6509 103.015 40.9785 103.032 42.6607L103.483 96.1409C103.5 97.8229 102.174 99.1759 100.492 99.1909Z",
    fill: "#E6E5EF"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M71.7375 79.1193L50.0476 79.27L60.7996 66.8944L71.7375 79.1193Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M89.724 78.9726L58.4568 79.195L73.9418 61.4233L89.724 78.9726Z",
    fill: "#8D8CAF"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M60.7787 61.4514C62.4936 59.9765 62.6868 57.3891 61.2102 55.6722C59.7336 53.9554 57.1464 53.7593 55.4316 55.2342C53.7167 56.7091 53.5235 59.2965 55.0001 61.0133C56.4766 62.7302 59.0638 62.9263 60.7787 61.4514Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M84.6642 116.059C84.3578 117.358 83.8982 118.732 83.3614 119.878C81.9055 122.704 79.6069 124.919 76.7718 126.371C73.86 127.822 70.4119 128.433 66.9639 127.669C58.8417 125.989 53.6312 118.046 55.317 109.949C57.0027 101.852 64.895 96.582 73.0172 98.3378C75.9289 98.9497 78.4576 100.401 80.603 102.387C84.2046 105.977 85.7367 111.171 84.6642 116.059Z",
    fill: "#F1F1F5",
    stroke: "#D3D2E0",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M74.7228 110.722H72.2777V108.278C72.2777 107.088 71.3421 106 70.0002 106C68.8102 106 67.7228 106.935 67.7228 108.278V110.722H65.2778C64.0878 110.722 63.0002 111.659 63.0002 113C63.0002 113.616 63.2199 114.198 63.6498 114.628C64.0797 115.058 64.6615 115.278 65.2778 115.278H67.7228V117.722C67.7228 118.913 68.6584 120 70.0002 120C71.1902 120 72.2777 119.065 72.2777 117.722V115.278H74.7228C75.9127 115.278 77.0002 114.342 77.0002 113C77.0002 111.659 75.9127 110.722 74.7228 110.722Z",
    fill: "white",
    stroke: "#D3D2E0",
    strokeWidth: "2"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M9.20024 87.6001C12.0721 87.6001 14.4002 85.2721 14.4002 82.4001C14.4002 79.5281 12.0721 77.2 9.20024 77.2C6.32834 77.2 4.00024 79.5281 4.00024 82.4001C4.00024 85.2721 6.32834 87.6001 9.20024 87.6001Z",
    fill: "#9F9FBC"
  })]
});
exports.UploadEmptyImage = UploadEmptyImage;